import { Container, GreyBar } from './ExperimentBudget.styles';
import Payment from './Payment';
import Price from './Price';
import TradeCard from '../TradeCard';

export default function ExperimentBudget() {
  return (
    <Container>
      <Payment />
      <GreyBar />
      <Price />
      <div className="pt-16">
        <TradeCard />
      </div>
    </Container>
  );
}
